import Image from "./image";
import ImageGroup from "./image-group";
Image.Group = ImageGroup;
export default Image;
//# sourceMappingURL=index.js.map